import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const DrawerContent: FC<Props> = ({ children }) => (
  <Box sx={{ px: 3, pb: 3 }}>{children}</Box>
);
